// Esporta l'ESSENZA di un manifesto, per il workflow n8n «Set Sfondi».
//
// Giotto compone il tema e lo esporta così com'è: un prompt solo, quello che il
// grafico ha appena visto nell'anteprima. Non sa che un set è fatto di
// quattordici tagli, né che tre di loro portano una figura sacra, né in che
// formati. Quelle sono configurazioni del set, cambiano man mano che il set
// viene usato, e vivono in n8n — insieme alla tabella dei tagli.
//
// Il formato non compare nel prompt: la forma la decide `image_size` nella
// chiamata a gpt-image-2, e il modello compone per quel telaio. Misurato: lo
// stesso prompt reso a 2416x3424 e a 3424x2416 dà due composizioni corrette, e
// un prompt che dichiara «verticale» reso a misura orizzontale esce comunque
// orizzontale.
//
// L'essenza conviene tenerla spoglia: n8n appende la figura sacra nell'angolo
// inferiore sinistro, e se il tema ci ha già messo qualcosa la figura si
// affianca invece di sostituirla.

// v3: `prompt` è l'essenza, una stringa sola. La v2 portava quattro prompt (uno
// per variante), la v1 otto (varianti × orientamenti): in entrambe il neutro
// era l'essenza, e n8n lo ricava ancora da lì per non far fallire un brief
// vecchio.
export const SET_BRIEF_VERSION = 3;

const clone = (value) => JSON.parse(JSON.stringify(value));

/**
 * @param {Object} state stato del builder (non viene mutato).
 * @param {Object} [opzioni]
 * @param {string|null} [opzioni.prompt] prompt da esportare. Serve quando il
 *   super user ha riscritto a mano il testo: senza, il brief esporterebbe in
 *   silenzio qualcosa che l'utente non ha mai letto.
 * @returns {{version: number, state: Object, prompt: string}}
 */
export function composeSetBrief(state, opzioni = {}) {
  const prompt = opzioni.prompt;
  if (typeof prompt !== 'string' || !prompt.trim()) {
    throw new Error('Nessun prompt da esportare nel brief del set.');
  }
  return {
    version: SET_BRIEF_VERSION,
    // Lo stato serve a riaprire il tema in un secondo momento, non a n8n.
    state: clone(state),
    prompt,
  };
}

export default composeSetBrief;
